// PC Shop — comportamiento compartido de blocks/pcshop-product-card.liquid.
// Un solo archivo cargado una vez (layout/theme.liquid), funciona para
// cualquier sección que use la card única: colección, búsqueda, home/
// featured, recomendaciones de la PDP — sin duplicar JS por sección
// (antes vivía inline en main-collection.liquid, Tarea 11b/11c).

document.addEventListener(
  'DOMContentLoaded',
  () => {
    const url = new URL(window.location.href);
    if (!url.hash) return;
    const target = document.getElementById(url.hash.slice(1));
    if (target) target.scrollIntoView({ behavior: 'instant' });
  },
  { once: true }
);

// Pastilla "Ver precio en divisas": el form nativo 'localization' usa `back`
// de Liquid para return_to, pero viene vacío en colección/búsqueda/home
// (confirmado con un dump real) — perdía página/filtro/orden al volver. Un
// solo listener delegado completa return_to con la URL real justo antes de
// enviar, página + query + el ancla que cada sección le pone a su card.
document.addEventListener('submit', (event) => {
  const form = event.target.closest('.pcshop-card__divisas-form');
  if (!form) return;
  const anchor = form.getAttribute('data-pcshop-anchor');
  const returnTo = form.querySelector('input[name="return_to"]');
  if (anchor && returnTo) {
    returnTo.value = window.location.pathname + window.location.search + '#' + anchor;
  }
});

// Pastilla "Ahorras $X" en mercado Divisas: el precio VE de cada producto no
// se busca por card — un solo fetch por contenedor con
// data-pcshop-collection-handle a /{prefijo VE}/collections/{handle}/products.json,
// arma un mapa variant_id -> precio VE, llena cada pastilla que coincida.
// Si el id no aparece (colección de más de 250 productos) o el ahorro no es
// positivo, la pastilla se queda hidden para siempre — nunca "$0.00".
document.querySelectorAll('[data-pcshop-collection-handle]').forEach((container) => {
  const handle = container.getAttribute('data-pcshop-collection-handle');
  const marketPathVe = container.getAttribute('data-pcshop-market-path-ve') || '/es-ve';
  const pills = container.querySelectorAll('[data-pcshop-save-pill]');
  if (!handle || pills.length === 0) return;

  fetch(`${marketPathVe}/collections/${handle}/products.json?limit=250`)
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (!data || !Array.isArray(data.products)) return;
      const vePriceByVariant = new Map();
      data.products.forEach((product) => {
        (product.variants || []).forEach((variant) => {
          vePriceByVariant.set(String(variant.id), Math.round(Number(variant.price) * 100));
        });
      });
      pills.forEach((pill) => {
        const variantId = pill.getAttribute('data-pcshop-variant-id');
        const usdCents = Number(pill.getAttribute('data-pcshop-usd-cents'));
        const veCents = vePriceByVariant.get(variantId);
        if (veCents === undefined || !Number.isFinite(usdCents)) return;
        const saveCents = veCents - usdCents;
        if (saveCents <= 0) return;
        const dollars = Math.floor(saveCents / 100);
        const cents = String(saveCents % 100).padStart(2, '0');
        pill.textContent = `Ahorras $${dollars}.${cents}`;
        pill.hidden = false;
      });
    })
    .catch(() => {});
});
